import React from 'react';
import PropTypes from 'prop-types';
import { useAmp } from 'next/amp';
import styled from 'styled-components';
import buildConfig from 'app/utils/buildConfig';

const Container = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 50px;
`;

const ViewNonAmpLink = ({ slug }) => {
  const isAmp = useAmp();
  if (!isAmp) return null;
  const url = `${buildConfig.blogHost}${slug}`;
  return (
    <Container>
      <a href={url}>View Non-AMP Version</a>
    </Container>
  );
};

ViewNonAmpLink.propTypes = {
  slug: PropTypes.string.isRequired,
};

export default ViewNonAmpLink;
